import { render, staticRenderFns } from "./PrismInput.vue?vue&type=template&id=5aa9a547"
import script from "./PrismInput.vue?vue&type=script&lang=js"
export * from "./PrismInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports